import * as types from './types';

const INITIAL_STATE = {
  sites: [],
  selectedSites: [],
  report: null,
  loading: null,
  error: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.CEP_FUNDS_DUE_REPORT_GET_SITES:
      let allowedSites = [];
      if (payload && payload.length > 0) {
        payload
          .filter(
            s =>
              s.AlternateProvisionTypeId === 3 &&
              s.IsLicensed &&
              s.IsActive &&
              s.Allowed
          )
          .forEach(function(e) {
            allowedSites.push({
              Id: e.Id,
              Description: e.Description,
              SiteGroupId: e.SiteGroupId ? e.SiteGroupId.toString() : null,
              SiteGroupName: e.SiteGroup,
              IsLicensed: e.IsLicensed,
              IsActive: e.IsActive,
            });
          });
      }

      return {
        ...state,
        sites: allowedSites,
      };

    case types.CEP_FUNDS_DUE_REPORT_SET_SELECTED_SITES:
      return {
        ...state,
        selectedSites: payload,
      };

    case types.CEP_FUNDS_DUE_REPORT_GET_REPORT:
      return {
        ...state,
        report: payload,
      };

    case types.CEP_FUNDS_DUE_REPORT_LOADING:
      return {
        ...state,
        loading: payload,
      };

    case types.CEP_FUNDS_DUE_REPORT_ERROR:
      return {
        ...state,
        error: payload,
      };

    case types.CEP_FUNDS_DUE_REPORT_CLEAR_REPORT:
      return {
        ...state,
        report: null,
        error: null,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/cepfundsdue/state/report/reducer.js